import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ActivationRequests from './pages/ActivationRequests';
import Licenses from './pages/Licenses';
import Customers from './pages/Customers';
import UserActivity from './pages/UserActivity';
import GeoAnalytics from './pages/GeoAnalytics';
import Sidebar from './components/Sidebar';
import './App.css';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('user');
    return saved ? JSON.parse(saved) : null;
  });

  const handleLogin = (newToken, userData) => {
    setToken(newToken);
    setUser(userData);
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  if (!token) {
    return <Login onLogin={handleLogin} />;
  }

  const isStaff = user?.role === 'staff';

  return (
    <BrowserRouter>
      <div className="app-container">
        <Sidebar onLogout={handleLogout} isStaff={isStaff} user={user} />
        <div className="main-content">
          <Routes>
            {!isStaff && <Route path="/" element={<Dashboard />} />}
            <Route path="/requests" element={<ActivationRequests />} />
            {!isStaff && <Route path="/licenses" element={<Licenses />} />}
            {!isStaff && <Route path="/customers" element={<Customers />} />}
            {!isStaff && <Route path="/activity" element={<UserActivity />} />}
            {!isStaff && <Route path="/geo" element={<GeoAnalytics />} />}
            <Route path="*" element={<Navigate to={isStaff ? "/requests" : "/"} />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;